<template>
    <div>
       <HeaderTeam header="ตารางการทำงาน" :img_header="header_image" link_back="manageworkschedule"/>
       <AllScheduleList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/schedule_1.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import AllScheduleList from '@/components/menuadmin/team/teamworkschedule/AllScheduleList.vue'
export default {
    name:'allSchedule',
    components:{
        HeaderTeam,
        AllScheduleList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>